import { EmployeeDto } from 'gleblu-socket-api';

import Employee from '../interfaces/Employee';

export function fromDto(employeeDto: EmployeeDto): Employee {
  const { userUuid, companyUuid, email, firstName, lastName, phoneNumber, accountActivated, placePermissions } = employeeDto;

  return {
    userUuid,
    companyUuid,
    email,
    firstName,
    lastName,
    phoneNumber,
    accountActivated,
    placePermissions,
  };
}

export function toDto(employeeDto: Employee): EmployeeDto {
  const { userUuid, companyUuid, email, firstName, lastName, phoneNumber, accountActivated, placePermissions } = employeeDto;

  return {
    userUuid,
    companyUuid,
    email,
    firstName,
    lastName,
    phoneNumber,
    accountActivated,
    placePermissions,
  };
}
